<template>
    <div class="integral-module">
        <div class="HomeTitle">
            <div class="head">
                <div class="openhead">
                    <img class="headimg" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png" alt="">
                </div>
                <div class="info">
                    <div class="infoname">
                        <div class="name">{{ myData.empName }}</div>
                        <div class="post">{{ myData.empPost }}</div>
                        <div class="rule-btn" @click="openRule">积分规则</div>
                    </div>
                    <div class="infostore" v-if="myData.storeName">{{ myData.storeName }}</div>
                </div>
            </div>
            <div class="number-box">
                {{ myData.score }}
                <span class="txt">积分</span>
            </div>
            <div class="menu-box">
                <div class="menu-item" @click="toBiDetail">
                    <img class="menu-img" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/detail.png" alt="">
                    <div class="menu-txt">积分明细</div>
                </div>
                <div class="line"></div>
                <div class="menu-item" @click="toBiRecord">
                    <img class="menu-img" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/record.png" alt="">
                    <div class="menu-txt">兑换记录</div>
                </div>
            </div>
        </div>
        <!-- 列表 -->
        <div class="list-box">
            <van-tabs animated :active="tabNum" @change="changeTab" v-if="tabList.length != 0">
                <van-tab v-for="(item, index) in tabList" :key="index" :title="item.title">
                    <div v-if="showEmpty">
                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无商品" />
                    </div>
                    <div v-else class="content service" style="margin-top: 15px;">
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" :immediate-check="false">
                            <div class="list flex-row flex-between">
                                <div class="item flex-col flex-y-center" v-for="(item, index) in listData" :key="index" @click="toDetailPage(item.id)">
                                    <img class="img" mode='aspectFill' :src="item.listImg" alt="" />
                                    <div class="title">{{ item.title }}</div>
                                    <div class="title red" v-if="item.price > 1 && item.isAll != 1">{{ item.price }}积分
                                    </div>
                                    <div class="title red" v-else-if="item.isAll == 1">1-9999积分</div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-tab>
            </van-tabs>
            <div v-if="tabList.length == 0">
                <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无商品" />
            </div>
        </div>
        <!-- 规则弹框 -->
        <van-overlay :show="show" :lock-scroll="false">
            <div class="position-center font24 overlay">
                <div class="overlay-title">积分规则</div>
                <!-- <img class="closes" src="https://static.beautyfarm.com.cn/beauty_img/20210712/close.png" alt="" /> -->
                <van-icon name="cross" class="closes" @click="closeRule" />
                <!-- <div class="tit">1、新用户积分奖励</div> -->
                <div class="rule-box">
                    <div class="">每月兑换时间截止至当月30日，发货时间为下月，本月兑换下月发。</div>
                    <div class="tit">例如：小美2月10日获得100个积分，在3月16日兑换奖品，则订单随4月份订单进行，发货时间为4月下旬。</div>
                </div>

            </div>
        </van-overlay>
    </div>
</template>

<script>
import request from "@/utils/request";
import { keepAliveAfterHandler } from "@/router/router";
import { Toast } from 'vant'
export default {
    name: 'integralJoin',
    components: {},
    data() {
        return {
            show: false,
            myData: {},// 个人信息
            tabList: [],
            tabNum: 0, // tab下标
            listData: [],
            showEmpty: false,
            page: 1, // 页码
            sScroll: true, // 是否继续自增页码
            loading: false,
            finished: false,

        }
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    mounted() {
        this.getMyData()
        this.getTab().then(() => {
            this.getList();
        });
    },
    methods: {
        // 个人信息
        getMyData() {
            return request({
                url: `/my/myDataJm`,
                method: "get",
            }).then((res) => {
                this.myData = res.data;
                this.$store.state.user.name = res.data.empName

            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })

        },
        // tab列表
        getTab() {
            return request({
                url: `/jm/goods/getCategoryList`,
                method: "get",
            }).then((res) => {
                this.tabList = res.data;
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 切换tab类别
        changeTab(e) {
            this.tabNum = e
            this.listData = []
            this.page = 1
            this.showEmpty = false
            this.finished = false
            this.getList();
        },
        // 商品列表
        getList() {
            this.loading = true
            return request({
                url: `/jm/goods/getGoodslist?categoryId=` +
                    this.tabList[this.tabNum].id +
                    "&page=" +
                    this.page,
                method: "get",
            }).then((res) => {
                if (res.data.length == 0) {
                    this.showEmpty = this.page == 1 ? true : false
                    this.finished = true
                } else {
                    this.listData = this.page == 1 ? res.data : this.listData.concat(res.data)
                    this.page++
                }
            }).catch((error) => {
                this.finished = true
                Toast({ position: 'top', message: error ?? '' })
            }).finally(() => {
                this.loading = false
            })

        },
        // 跳转明细
        toBiDetail() {
            console.log(111)
            this.$router.push({ name: 'biDetailJoin', query: {}, });
        },
        // 跳转记录
        toBiRecord() {
            this.$router.push({ name: 'biRecordJoin', query: {}, });
        },
        // 跳转产品详情
        toDetailPage(id) {
            this.$router.push({ name: "productDetailJoin", query: { id: id } });
        },
        // 规则弹框
        openRule() {
            this.show = true
        },
        // 关闭规则弹框
        closeRule() {
            this.show = false

        },
    },
}
</script>

<style scoped lang="less">
.integral-module {
    width: 750px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}

.HomeTitle {
    width: 750px;
    height: 510px;
    background: linear-gradient(90deg, #1db2e4 0%, #4ae0d9 100%);
    color: #fff;
    position: relative;
    box-sizing: border-box;
    font-size: 34px;
    padding-top: 49px;
}

.head {
    margin-left: 30px;
    // margin-top: 49px;
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
}

.openhead {
    width: 130px;
    height: 130px;
}

.head .headimg {
    width: 130px;
    height: 130px;
    display: block;
    overflow: hidden;
    border-radius: 50%;
}

.info {
    flex: 1;
    height: 130px;
    padding-left: 30px;
    box-sizing: border-box;
}

.infoname {
    height: 50%;
    font-weight: bold;
    font-size: 34px;
    line-height: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.infoname .name {
    height: 50%;
}

.infoname .post {
    height: 50%;
    font-size: 26px;
    margin-left: 20px;
    flex: 1;
    color: #d5f3f8;
}

.infostore {
    height: 50%;
    display: flex;
    align-items: center;
    font-size: 26px;
    color: #d5f3f8;
}

.rule-btn {
    width: 160px;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 25px;
    font-size: 24px;
    font-weight: normal;
    line-height: 50px;
    margin-right: 60px;
    text-align: center;
    color: #d5f3f8;
}

.number-box {
    height: 188px;
    text-align: center;
    line-height: 188px;
    font-size: 70px;
    font-weight: 700;
}

.number {
    margin: 0 auto;
}

.txt {
    font-size: 24px;
    font-weight: 400;
    color: #d5f3f8;
}

.menu-box {
    width: 690px;
    height: 184px;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    position: absolute;
    left: 4%;
    bottom: -105px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #a0acb5;
}

.menu-item {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.menu-img {
    width: 46px;
    height: 46px;
}

.menu-txt {
    font-size: 30px;
    margin-top: 16px;
}

.line {
    width: 2px;
    height: 50px;
    background: #a0acb5;
}

/* 列表 */
.list-box {
    margin-top: 145px;
    padding: 0 30px;
}

.content {
    position: relative;
}

:deep(.van-tabs__line) {
    display: none;
}

:deep(.van-tab) {
    /* flex: none !important; */
    flex: 0 0 28% !important;
    /* width: 184px !important; */
    padding: 0 !important;
    height: 70px !important;
    line-height: 70px !important;
    color: #35434c;
}

:deep(.van-tab > span) {
    width: 100%;
    text-align: center;
}

:deep(.van-tab--active > .van-tab__text--ellipsis) {
    /* width: 184px !important; */
    height: 70px !important;
    line-height: 70px;
    background: #2fd0d5 !important;
    border-radius: 35px !important;
    color: #fff !important;
    // padding: 0 16px;
}

:deep(.van-tabs__nav--line) {
    overflow-x: auto;
}

.content .list {
    width: 690px;
    flex-flow: wrap;
}

.content .list .item {
    width: 320px;
    margin-bottom: 50px;
}

.content .list .item .img {
    width: 320px;
    height: 320px;
    border-radius: 10px;
}

.content .list .item .title {
    font-size: 30px;
    color: #35434c;
    padding-top: 20px;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.content .list .item .title.red {
    color: #ee4c4c;
}

/* 规则弹框 */
.overlay {
    width: 580px;
    height: 511px;
    background: #ffffff;
    border-radius: 16px;
    padding: 40px 40px;
    box-sizing: border-box;
    color: #35434c;
    line-height: 44px;
    z-index: 99;
    overflow: hidden;
}

.overlay-title {
    width: 400px;
    height: 40px;
    font-size: 34px;
    line-height: 40px;
    color: #35434c;
    font-weight: bold;
    padding-left: 35%;
    box-sizing: border-box;
    margin-bottom: 30px;
}

.scroll-center {
    width: 100%;
    height: 680px;
}

.closes {
    position: absolute;
    top: 46px;
    right: 30px;
    width: 40px;
    height: 40px;
}

.overlay .tit {
    margin-bottom: 40px;
}

.rule-box {
    height: 100%;
    overflow-y: auto;
}
</style>
